import React, { Fragment } from 'react';

const ProductShippingAndDelivery = ({ shippingInfo }) => {
  return (
    <>
      {shippingInfo.map((row, index) => (
        <Fragment key={index}>
          {row.value && (
            <div className="[ product-specifications__shipping-info ] [ text-medium text-large-from-large ]">
              <span className="bold">{row.name}</span>
              <div dangerouslySetInnerHTML={{ __html: row.value }}></div>
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default ProductShippingAndDelivery;
